import { render, staticRenderFns } from "./TCLAOpportunities.vue?vue&type=template&id=7f81451a&scoped=true"
import script from "./TCLAOpportunities.vue?vue&type=script&lang=js"
export * from "./TCLAOpportunities.vue?vue&type=script&lang=js"
import style0 from "./TCLAOpportunities.vue?vue&type=style&index=0&id=7f81451a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f81451a",
  null
  
)

export default component.exports